import { render, staticRenderFns } from "./WebsiteKnowledgebaseList.vue?vue&type=template&id=a397b762&"
import script from "./WebsiteKnowledgebaseList.vue?vue&type=script&lang=js&"
export * from "./WebsiteKnowledgebaseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports